import * as React from 'react'

import DialogActions  from '@material-ui/core/DialogActions/DialogActions'
import DialogContent  from '@material-ui/core/DialogContent'
import { withFormik } from 'formik'

import { Program }                                   from '../../api'
import { ActionButton, InlineError, LoadingOverlay } from '../atoms'
import loadable                                      from '../hocs/loadable'
import { FullScreenDialog }                          from '../molecules'

import { MentoringProgramChunk }                    from './chunks'
import { genValueMapper, proxyFormikSubmission }    from './form-utils'
import { editProgramSchema, emptyMentoringProgram } from './schemas'

const LoadableEditProgramForm = withFormik<any, Program>({
  validationSchema: editProgramSchema,
  mapPropsToValues: genValueMapper(emptyMentoringProgram),
  handleSubmit:     proxyFormikSubmission,
})(
  loadable(
    ({
      fetching,
      handleSubmit,
      error,
      isOpen,
      close,
      ...rest
    }: any) => (
      <LoadingOverlay show={fetching}>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <MentoringProgramChunk mode={'edit'} {...rest} />
          </DialogContent>
          {error && (
            <DialogContent>
              <InlineError i18nErrorId={error} />
            </DialogContent>
          )}
          <DialogActions>
            <ActionButton
              type={'submit'}
              actionType={'submit'}
              variant={'raised'}
              color={'secondary'}
            />
          </DialogActions>
        </form>
      </LoadingOverlay>
    )
  )
)

class ProgramEditForm extends React.Component<any> {
  public componentDidUpdate (lastProps) {
    const wasEdited =
      lastProps.fetching
      && this.props.success

    if (wasEdited) {
      this.props.close()
    }
  }

  public render () {
    const {
      isOpen,
      close,
      values,
      ...rest
    } = this.props

    return (
      <FullScreenDialog
        close={close}
        isOpen={isOpen}
        title={'editProgram'}
      >
        <LoadableEditProgramForm
          key={values.processes && values.processes.length}
          values={values}
          {...rest}
        />
      </FullScreenDialog>
    )
  }
}

export default ProgramEditForm



// WEBPACK FOOTER //
// ./src/components/forms/ProgramEditForm.tsx